import React from 'react'

import { useSurveyQueryData } from './useSurveyQueryData'

export const useSurveyQueryBrandGroups = () => {
  const survey = useSurveyQueryData()

  return React.useMemo(() => survey?.brandGroups ?? [], [survey?.brandGroups])
}
